export default __webpack_public_path__ + "static/media/login-image.47e5bdeb.png";